module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/075-antigua-and-barbuda-d8248fd7bc5ee5ba317570033d703380.svg";